import useOnLoad from '~/routes/use-on-load';
import useSurchargesBackgroundTasks from './useSurchargesBackgroundTask';
import useClaimsBackgroundTask from './useClaimsBackgroundTask';
import useSupportBackgroundTask from './useSupportBackgroundTask';

const SupportBackgroundTasks: React.FC = () => {
  useSurchargesBackgroundTasks();
  useClaimsBackgroundTask();
  useSupportBackgroundTask();

  // App Start
  useOnLoad(() => {
    console.log('SupportBackgroundTasks: Loaded');
  });

  return null;
};

export default SupportBackgroundTasks;
